// Label

//? Label - Color
export const setTextAreaColorStyles = (theme) => {
  return {
    color: theme.palette.primary.main,
  };
};

//? Label - Display
export const setTextAreaDisplayStyles = (label) => {
  if (label === "" || label === undefined) {
    return { display: "none", justifyContent: "center", alignItems: "center" };
  } else {
    return { display: "flex" };
  }
};

//? Label - Font
export const setTextAreaFontStyles = (size) => {
  //   Size Lookup Object
  const InputFontLookup = {
    xs: { fontSize: "10px" },
    sm: { fontSize: "12px" },
    md: { fontSize: "24px" },
    lg: { fontSize: "16px" },
  };

  const sizeKey = InputFontLookup[size] ? size : "md";

  return InputFontLookup[sizeKey];
};

//? Label - Size
export const setTextAreaSizeStyles = (size) => {
  //   Size Lookup Object
  const TextAreaLookup = {
    xs: { height: "20px", width: "100%" },
    sm: { height: "24px", width: "100%" },
    md: { height: "40px", width: "100%" },
    lg: { height: "32px", width: "100%" },
  };

  const sizeKey = TextAreaLookup[size] ? size : "md";

  return TextAreaLookup[sizeKey];
};
